import UploadBlock from "./UploadBlock";
import { REQUIRED_DOCS } from "../data";
import type { FormErrors, KycForm, SetDoc } from "../types";

interface Props {
  form: KycForm;
  errors: FormErrors;
  setDoc: SetDoc;
  retailerId?: string;
}

export default function BusinessDocumentsStep({ form, errors, setDoc, retailerId }: Props) {
  const required = form.businessType ? (REQUIRED_DOCS[form.businessType] ?? []) : [];
  const typeName = form.businessType || "your business";

  return (
    <div>
      <h3 className="text-lg font-semibold text-ink">Business Documents</h3>
      <p className="text-[13px] text-ink-secondary">
        Required documents for a {typeName}
      </p>

      <div className="mt-6 flex flex-col gap-4">
        {required.map((doc) => (
          <UploadBlock
            key={doc.key}
            label={doc.label}
            required
            helper={doc.helper}
            value={form.docs[doc.key] ?? null}
            onChange={(d) => setDoc(doc.key, d)}
            error={errors[`doc_${doc.key}`]}
            retailerId={retailerId}
          />
        ))}

        <UploadBlock
          label="Other Supporting Document"
          helper="Shop licence, trade licence or any other business registration"
          value={form.docs.otherSupporting ?? null}
          onChange={(d) => setDoc("otherSupporting", d)}
          retailerId={retailerId}
        />
      </div>
    </div>
  );
}